export const useSearchParams = () => {
    const getVal = (key) => {
        let params

        try {
            params = new URL(window.location.toString()).searchParams
        } catch {
            return null
        }

        try {
            return JSON.parse(params.get(key))
        } catch {
            return params.get(key)
        }
    }

    return { getVal }
}
